module.exports = __webpack_public_path__ + "img/circuit-board.674c5b31.svg";